import * as requests from './requests';
import * as responses from './responses';

export default {
    requests,
    responses,
};
